import configureStore from "./configureStore";

const setupStore = () => {
    return configureStore();
};

export default setupStore;

export type RootState = ReturnType<ReturnType<typeof setupStore>['getState']>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];